

import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { getCityList, signCheck } from '@/services/finance';

export interface FinanceState {
  signQualification: boolean;
  cities: {
    cityList: string[];
    provinceName: string;
  }[]
}

const initialState: FinanceState = {
  signQualification: false,
  cities: [],
};

export const checkSignQualification = createAsyncThunk('finance/qualification', signCheck);
export const fetchCities = createAsyncThunk('finance/city', getCityList);

export const finance = createSlice({
  name: 'auth',

  initialState,

  reducers: {
  },
  extraReducers: (builder) => {
    builder.addCase(checkSignQualification.fulfilled, (state, { payload }) => {
      state.signQualification = payload;
    });
    builder.addCase(fetchCities.fulfilled, (state, { payload }) => {
      state.cities = payload;
    });
  },
});

export default finance.reducer;
